export const name = '@lifi/sdk-provider-sui'
export const version = '4.2.4'
